import { DOMAIN } from './UserDetails.constants';
import get from 'lodash/get';

export const getStore = state => get(state, DOMAIN) || {};

export const getId = state => getStore(state).id;
export const getError = state => getStore(state).error;

export const isLoading = state => getStore(state).loading;
